module.exports = __webpack_public_path__ + "img/bobut_bobocoin.gm.508cc53.png";